import { axiosICPLBEInstance } from "../../../utils/axios_config";

export default function VehicleService() {
    this.getVehicles = (payload) => {
        return axiosICPLBEInstance.get(`vehicle?page=${payload.page}&page_length=${payload.page_length}`);
    }
}